import React, { Component } from 'react';
import { connect } from 'react-redux';
import { STooltip } from '@avalara/skylab-sdk/react';

import LANGUAGES_CONTROLLER, {DEFAULT_LANGUAGE_STRINGS}  from '../../../controllers/languages';

import Logger, {LOG_LEVELS} from '../../../utils/logger';

const log = new Logger('LANGUAGE_STRING_RESOLVER', LOG_LEVELS.ERROR);

class LanguageStringResolver extends Component {
  constructor(props) {
    super(props);
    this.tooltipTriggerId = `language-string-resolver-${Math.random().toString(36).slice(2)}`;
    this.tooltipId = `${this.tooltipTriggerId}-tooltip`;
  }
  
  render() {
    let tooltipParams = this.props.tooltipWithParams ? this.props.params : [];
    const dataTip = this.props.tooltip ? LANGUAGES_CONTROLLER.formatUtilFormatter(this.props.languageStrings, this.props.tooltip, tooltipParams) : undefined;    
    if(dataTip) {
      return (
        <span id={this.tooltipTriggerId} className={this.props.className} tabIndex="0" aria-describedby={this.tooltipId}>
          {LANGUAGES_CONTROLLER.formatUtilFormatter(this.props.languageStrings, this.props.string, this.props.params)}
          <STooltip triggerId={this.tooltipTriggerId} tooltipId={this.tooltipId}>
            <span slot="content">{dataTip}</span>
          </STooltip>
        </span>
      )
    } else {
      return (
        <span className={this.props.className}>
          {LANGUAGES_CONTROLLER.formatUtilFormatter(this.props.languageStrings, this.props.string, this.props.params)}
        </span>
      );
    }
  }
}
function mapStateToProps(state, props) {
  // log.debug('mapStateToProps: ', state);
  return {
    languageStrings: props.languageStrings || (state.languages && state.languages.data) || DEFAULT_LANGUAGE_STRINGS
  };
}

LanguageStringResolver.defaultProps = {
  tooltipWithParams: true
};

export default connect(mapStateToProps)(LanguageStringResolver);
